import $ from "jquery";
import "slick-carousel";

// const sliderOnScroll = () => {
//   const el = {
//     container: ".CustomizerSection",
//     sliderEl: ".CustomizerSection .js-CustomizerSlider",
//     image: ".CustomizerSection .js-CustomizerSlider img",
//     window: ".Customizer__Text",
//     class: ".js-scrollspyImage",
//   };

//   if ($(el.container).length === 0) return;

//   $(el.sliderEl).slick({
//     dots: false,
//     prevArrow: false,
//     nextArrow: false,
//     infinite: true,
//     // speed: 1000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//   });
//   let additionalHeight = 166;

//   if ($(window).width() < 1128) {
//     additionalHeight = 147;
//   } else if ($(window).width() < 600) {
//     additionalHeight = 144;
//   }
//   // listening on scroll
//   $(el.window).on("scroll", function () {
//     const currentTop = $(el.window).scrollTop();
//     const elems = $(el.class);
//     // loop each element
//     elems.each(function () {
//       const elemTop = $(this).offset().top;
//       const elemBottom = elemTop + $(this).height();

//       if (
//         currentTop + additionalHeight >= elemTop &&
//         currentTop + additionalHeight <= elemBottom
//       ) {
//         const id = $(this).attr("id");
//         // const navElem = $('a[href="#' + id + '"]');
//         const element = $("#img-" + id).closest(".slick-slide");
//         if (element.length > 0) {
//           const indexSlick = element.attr("data-slick-index");
//           $(el.sliderEl).slick("slickGoTo", indexSlick);
//         } else {
//           // eslint-disable-next-line no-console
//           // console.log("Element with ID not found:", id);
//         }
//         // console.log(id);
//       }
//     });
//   });
// };

const scrollspyNavbar = () => {
  const el = {
    container: ".CustomizerSection",
    window: ".Customizer__Text",
    class: ".CustomizerChildSection",
    navbarLink: ".CustomizerHeader__SectionLink",
    sliderEl: ".CustomizerSection .js-CustomizerSlider",
  };

  if ($(el.container).length === 0) return;

  const isElementInView = (elem) => {
    const rect = elem.getBoundingClientRect();
    const threshold = window.innerHeight - 650;
    return rect.top <= threshold && rect.bottom >= threshold;
  }
  
  const isScrolledToBottom = (elem) => {
    const rect = elem.getBoundingClientRect();
    return window.innerHeight + window.scrollY >= rect.bottom;
  };
  
  $(el.window).on("load resize scroll", function () {
    const elems = $(el.class)
    // loop each element
    elems.each(function () {
      const $element = $(this);
      if($element.is(':visible')){
        // console.log($element)
        if (isElementInView($element[0]) || isScrolledToBottom($element[0])) {
        // if (isElementInView($element[0])) {
          const id = $element.attr("id");
          const navElem = $(`a[href="#${id}"]`);
          navElem.addClass("active").siblings().removeClass("active");
        }
      }
    });
  });

  // change image and active navbar when clicked
  $(document).on("click", el.navbarLink, function () {
    const id = $(this).attr("href");

    $(el.navbarLink).removeClass("active");
    $(this).addClass("active");

     // if (elem.length > 0) {
      // const topOffset = elem[0].getBoundingClientRect().top;
      
      // console.log($(this))
      // // Scroll to the target element's top position
      // $(el.window).animate({
      //     scrollTop: window.scrollY + topOffset - window.innerHeight / 4
      // }, );

      // const elemRect = elem[0].getBoundingClientRect();
      // const windowHeight = window.innerHeight;
      // // const scrollPosition = elemRect.top + elemRect.height / 2 - windowHeight / 2;
      // let scrollPosition;

      // // Calculate the scroll position based on the element's position
      // if (elemRect.top < windowHeight / 3) {
      //   // If the element is near the top, scroll it to the top
      //   scrollPosition = elemRect.top;
      // } else if (elemRect.bottom > windowHeight / 3) {
      //   // If the element is near the bottom, scroll it to the bottom
      //   scrollPosition = elemRect.bottom - windowHeight;
      // } else {
      //   // If the element is in the middle, scroll it to the center
      //   scrollPosition = elemRect.top + elemRect.height / 3 - windowHeight / 3;
      // }
      // // Scroll the '.Customizer__Text' element to the center of the viewport
      // $(el.window).animate({
      //   scrollTop: scrollPosition
      // });
    // }

    const elementImage = $(id).find(".js-scrollspyImage").first().attr("id");
    const element = $(`#img-${elementImage}`).closest(".slick-slide");
    // const element = $("#img-" + id).closest(".slick-slide");
    if (element.length > 0) {
      const indexSlick = element.attr("data-slick-index");
      $(el.sliderEl).slick("slickGoTo", indexSlick);
    }
  });
};

try {
  // sliderOnScroll();
  scrollspyNavbar();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("Error:", error);
}
